import * as React from 'react';
import { Link } from 'react-router-dom';

export const Home = () => {
    return (
        <div className="container">
            <div className="py-3 my-3 text-center">
                <h2 className="display-5 fw-bold text-body-emphasis">Our Regattas</h2>
            </div>

            <div id="featured-3">
                <div className="row g-4 py-5 row-cols-1 row-cols-md-4">
                    <div className="feature col">
                        <div className="feature-icon d-inline-flex align-items-center justify-content-center text-bg-primary fs-2 mb-3">
                            <Link to="/hampton">
                                <img src="/images/hamptonBeach.jpg" alt="Hampton" className="img-thumbnail" />
                            </Link>
                        </div>
                        <Link to="/hampton">
                            <h3 className="fs-2">Hampton Beach</h3></Link>
                        <p>Located right on New Hampshire's beautiful Hampton Beach</p>
                    </div>
                    <div className="feature col">
                        <div className="feature-icon d-inline-flex align-items-center justify-content-center text-bg-primary fs-2 mb-3">
                            <Link to="/sebago">
                                <img src="/images/sebago.jpg" alt="Sebago" className="img-thumbnail" />
                            </Link>
                        </div>
                        <Link to="/sebago">
                            <h3 className="fs-2">Sebago Lake</h3></Link>
                        <p>A fun and enjoyable camping weekend in Maine's pristine Sebago Lake State Park.</p>
                    </div>
                    <div className="feature col">
                        <div className="feature-icon d-inline-flex align-items-center justify-content-center fs-2 mb-3">
                            <a href="http://rpmr.org">
                                <img src="/images/RotonPoint.svg"
                                    alt="Roton Point"
                                    className="img-thumbnail"
                                    target="_blank" rel="noreferrer"/>
                            </a>
                        </div>
                        <h3 className="fs-2"><a href="http://rpmr.org" target="_blank" rel="noreferrer">Roton Point Multihull Regatta</a></h3>
                        {/* <p>September 18 - 20, 2015</p> */}

                        <p>It's been called one of the most fun regattas of the year; informal, friendly, with great racing on Long Island Sound punctuated by our barbecue dinner and dance on Saturday night.</p>
                    </div>


                    <div className="col d-flex flex-column gap-2">
                        <div className="alert alert-info hidden-print hidden-xs hidden-sm affix">
                            <label>Club Favorites</label>
                            <ul>
                                <li>
                                    <a href="http://www.nacrasailing.com/" target="_blank" rel="noreferrer">NACRA</a>
                                </li>
                                <li>
                                    <a href="http://nensa.org" target="_blank" rel="noreferrer">NENSA</a>
                                </li>
                                <li>
                                    <a href="http://www.new-england-catamarans.com/" target="_blank" rel="noreferrer">New England Catamarans</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Home;
